import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/return-box-yellow.png'


const _hoisted_1 = { class: "ready-deiver" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center p-2 rounded-lg gap-2 btn-chce-resi max-w-md"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-check color-blue-grey" }, null, -1)
const _hoisted_7 = { class: "color-blue-grey" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-user-plus font-bold color-primary" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "font-bold color-primary color-primary" }, "Pilih Kurir", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "h-full",
  style: {"border-left":"1px solid #607D8B"}
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "font-bold color-primary color-primary" }, "Pengembalian", -1)
const _hoisted_13 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Urutkan : ")
const _hoisted_15 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_CardReadyDeliverV2 = _resolveComponent("CardReadyDeliverV2")
  const _component_VirtualScroll = _resolveComponent("VirtualScroll")
  const _component_ModalChangeCourier = _resolveComponent("ModalChangeCourier")
  const _component_ModalChangePackage = _resolveComponent("ModalChangePackage")
  const _component_FormAssignCourier = _resolveComponent("FormAssignCourier")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_ModalConfirmPackageReturn = _resolveComponent("ModalConfirmPackageReturn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Dropdown, {
          id: "option-search-id",
          modelValue: _ctx.option,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.option = $event)),
          options: _ctx.listOptionSearch,
          class: "dropdown-grey flex-shrink-0 text-sm",
          optionLabel: "name",
          optionValue: "id",
          placeholder: "No.Resi"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_InputIconRightGrey, {
          placeholder: "Cari Disini ...",
          type: _ctx.enumBase.input.text,
          modelValue: _ctx.inputSearch,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
          canClick: true,
          onSubmitInput: _ctx.onSearch,
          onKeyup: _withKeys(_ctx.onSearch, ["enter"]),
          icon: _ctx.iconLocal.svg.searchEva
        }, null, 8, ["type", "modelValue", "onSubmitInput", "onKeyup", "icon"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.deliveryWaybillChecked.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("p", _hoisted_7, _toDisplayString(`${_ctx.deliveryWaybillChecked.length} Resi Terpilih:`), 1),
              _createVNode("div", {
                class: "flex gap-2 ml-2 items-center cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showingSidebar()))
              }, [
                _hoisted_8,
                _hoisted_9
              ]),
              _hoisted_10,
              _createVNode("div", {
                class: "flex gap-2 ml-2 items-center cursor-pointer",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPackageReturn(_ctx.deliveryWaybillChecked, 0)))
              }, [
                _hoisted_11,
                _hoisted_12
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Multiselect, {
                id: "timeOrder",
                class: "can-not-empty input-primary",
                modelValue: _ctx.orderBy,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.orderBy = $event)),
                placeholder: "Waktu Order",
                options: _ctx.orderOption,
                label: "label",
                searchable: true,
                allowEmpty: false
              }, null, 8, ["modelValue", "options"])
            ]))
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_VirtualScroll, _mergeProps(_ctx.paramList, { ref: "refVS" }), {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (data, idx) => {
            return (_openBlock(), _createBlock(_component_CardReadyDeliverV2, {
              key: idx,
              data: data,
              index: idx,
              class: "mb-5",
              onChangeCourier: _ctx.onChangeCourier,
              onPackageReturn: _ctx.onPackageReturn,
              onTransferCourier: _ctx.onTransferCourier,
              onConfirmPackageReturn: _ctx.onConfirmPackageReturn
            }, null, 8, ["data", "index", "onChangeCourier", "onPackageReturn", "onTransferCourier", "onConfirmPackageReturn"]))
          }), 128))
        ]),
        _: 1
      }, 16)
    ]),
    (_ctx.isShowDialogCourier)
      ? (_openBlock(), _createBlock(_component_ModalChangeCourier, {
          key: 0,
          isShowDialog: _ctx.isShowDialogCourier,
          onHideDialog: _ctx.hideModalChangeCouirer,
          dataPackage: _ctx.dataTransferCourier,
          onReloadData: _ctx.reloadData,
          from: _ctx.fromPathChangeCourier
        }, null, 8, ["isShowDialog", "onHideDialog", "dataPackage", "onReloadData", "from"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogPackage)
      ? (_openBlock(), _createBlock(_component_ModalChangePackage, {
          key: 1,
          isShowDialog: _ctx.isShowDialogPackage,
          onHideDialog: _ctx.hideModalChangePackage,
          dataPackage: _ctx.multipleDataPackage,
          onSubmitPackageReturns: _ctx.submitPackageReturns
        }, null, 8, ["isShowDialog", "onHideDialog", "dataPackage", "onSubmitPackageReturns"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.isActiveSidebar,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isActiveSidebar = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        (_ctx.isActiveSidebar)
          ? (_openBlock(), _createBlock(_component_FormAssignCourier, {
              key: 0,
              deliveryWaybillChecked: _ctx.deliveryWaybillChecked,
              title: "Pilih Kurir",
              onCloseSidebar: _ctx.closeSidebar,
              onReloadData: _ctx.reloadData,
              onTransferCourier: _ctx.onTransferCourier
            }, null, 8, ["deliveryWaybillChecked", "onCloseSidebar", "onReloadData", "onTransferCourier"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ModalConfirmPackageReturn, {
      dataPackage: _ctx.dataConfirmPackageReturn,
      ref: "refModalConfirmPackageReturn",
      onReloadData: _ctx.reloadData
    }, null, 8, ["dataPackage", "onReloadData"])
  ]))
}